import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 创建Vue应用实例
const app = createApp(App)

// 使用路由
app.use(router)

// 在应用挂载前添加全局错误处理
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue应用错误:', err, instance, info)
}

// 在应用挂载前添加全局警告处理
app.config.warnHandler = (msg, instance, trace) => {
  console.warn('Vue应用警告:', msg, instance, trace)
}

// 挂载应用
app.mount('#app')

// 添加全局属性以方便调试
window.vueApp = app